import CoatApp from '@patientpattern/coat/ui/App';
import Loader from '@patientpattern/coat/ui/Loader';

import css from './Root.module.scss';
import Router from './Router';
import useTokenRefresh from './useTokenRefresh';

import {logout} from 'user/api';
import {useUserStore} from 'user/store';

const Root = () => {
    const id = useUserStore(state => state.id);

    useTokenRefresh(logout);

    return (
        <CoatApp>
            {id ?
                <Router />
            :   <Loader classNameRoot={css.loader} />}
        </CoatApp>
    );
};

export default Root;
